import { render } from "./App.vue?vue&type=template&id=8072bf68"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8072bf68&lang=scss"

import exportComponent from "/Users/bastiaanboekling/devops/afspraken/afspraken-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__